/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-02-10 15:16:23
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-03-14 20:55:51
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/customerReviews/scoreRating.tsx
 * @Description: default
 */
import { ReactNode } from "react";

interface Props {
  value: number;
  extra?: ReactNode;
  commentCount?: number;
  size?: number;
  starOnly?: boolean;
  starShow?: number;
}

export default function ScoreRating ({ starShow, value, extra, commentCount,size, starOnly = false}: Props) {
    const newValue = starShow || value;
    const fullStars = Math.floor(newValue);
    const hasHalfStar = newValue % 1 !== 0;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const stars = [];
    for (let i = 0; i < fullStars; i++) {
        stars.push(<i key={i} className="star full"></i>); // 实心星星
    }
    if (hasHalfStar) {
        stars.push(<i key="half" className="star half"></i>); // 半颗星星
    }
    for (let i = 0; i < emptyStars; i++) {
        stars.push(<i key={i + fullStars + 1} className="star empty"></i>); // 空心星星
    }

    return <div className={`comment-score-rating size${size || 16}`}>
      <div className="star-icon-box">
          {stars}
      </div>
      {!starOnly && <p className="basic-font">
          <span className="score-icon">{value}</span>
          { extra ||  <span >{commentCount}</span>}
      </p>}
    </div>
}